import { useModel, useParams, useRoute } from "@bcm-dev/bcms-vite";
import { UIPrimaryButton } from 'components/ui/UIButton';
import React from 'react';
import { SVGAsset } from 'res';
import './styles.css';

/**
 * @function CallTurnOffCardConfirmView
 * @return {React.Component}
 * @exported true
 * @description The view that shows the phone number for turning off the card
 */

export default function CallTurnOffCardConfirmView(props) {
  const { branding } = useModel();
  const navigate = useRoute();
  const defaultCard = branding.options.include_debit_chw23 !== "false" ? "0" : "1";
  const cardID = useParams().cardID ?? defaultCard;
  const onOK = () => navigate(`/home/recenttransactions/${ cardID }`);

  return(
    <div className="call-turn-off-card-confirm-view">
      <div className="framed-icon-container">
        <SVGAsset id="DocumentsAlertIcon" />
      </div>
      <p className="text-center call-text">Call to report your card lost or stolen.</p>
      <div className="flex-container button-container">
        <UIPrimaryButton text="OK" onClick={ onOK }  />
      </div>
    </div>
  );
}